export const containerHeaderTextStyle = {
  actionBtn: {
    textSize: 11,
  },

  variant: 'h4',
  style:   {
    fontWeight: 'bold',
    fontSize:   '1.2rem',
  },
  fontSize: 15,
};

export const sideBarMenuItemFontSize = 13;

// export default commonStyle;
